import { render, staticRenderFns } from "./AjanlatAdatokB39_V0.vue?vue&type=template&id=581352a8&"
import script from "./AjanlatAdatokB39_V0.vue?vue&type=script&lang=js&"
export * from "./AjanlatAdatokB39_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports